export const PROVISION_SUCCESS = 'provision-success';
export const SSR_SUCCESS = 'ssr-success';
